import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { AddFreeService } from '../add-free-service';
import { AddTrialApi } from '../../apis/add-free-api';
import { initCookieService } from '@telecom/shared/utils/init-cookie.ts';

// cSpell: ignore ADDTRIAL
const MAX_TRIAL_STORAGE_KEY = 'EUREKA_IP_ADDTRIAL_COUNT';
const MAX_TRIAL_STORAGE_COUNT = 5;

@injectable()
export class AddTrialServiceImpl implements AddFreeService {
    private _enableAutoAddTrial = true;

    constructor(
        @inject(AddTrialApi)
        private _addTrialApi: AddTrialApi,
    ) {}

    async addFreePkg(grantedProductIds: string[]): Promise<void> {
        try {
            if (grantedProductIds === undefined) {
                throw new Error('Granted_product_ids is undefined!');
            }

            const empowerType = this.getEmpowerType();
            const needAddTrialResult = await this._addTrialApi.needAddFreePkg(empowerType, {});
            this._enableAutoAddTrial = needAddTrialResult;

            const trialCounts = Number(sessionStorage.getItem(MAX_TRIAL_STORAGE_KEY) || 0);
            if (this._enableAutoAddTrial) {
                if (trialCounts > MAX_TRIAL_STORAGE_COUNT) {
                    sessionStorage.removeItem(MAX_TRIAL_STORAGE_KEY);
                    // 重定向到403页面
                    window.location.href = '/403/';
                    throw new Error(`Trial counts is over ${MAX_TRIAL_STORAGE_COUNT}!`);
                }
                await this._addTrialApi.addFreePkg({ empowerType ,extendBody: initCookieService.getTrackingParams() });

                // 清除缓存
                localStorage.removeItem('patsnap_header_account_info');
                // 清除token,强制让其去获取新的token
                localStorage.removeItem('patsnap-authorizations');

                // 记录试用次数
                sessionStorage.setItem(MAX_TRIAL_STORAGE_KEY, String(trialCounts + 1));

                // 重新加载页面
                window.location.reload();
            }
        } catch (error) {
            console.error('[AddTrial]', error);
        } finally {
            this._enableAutoAddTrial = false;
        }
    }


    getEmpowerType(from?: string): string {
        // cSpell: ignore hiro
        // 传"IP"会死循环,先传AIR
        return 'AIR';
        // return 'IP';
    }

    isAutoAddTrialEnabled(): boolean {
        return this._enableAutoAddTrial;
    }
}
